import React from 'react';
import GitHubActionsRegister from '../component/GitHubActionsRegister';

function GitHubActionsTraining() {
  return (
    <div id="myContactus">
      <GitHubActionsRegister />
    </div>
  );
}

export default GitHubActionsTraining;
